import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  PDF_TEMPLATE_LIST,
  PDF_TEMPLATE_RENDER,
  PDF_TEMPLATE_SAVE,
  PDF_TEMPLATE_DELETE,
  PDF_TEMPLATE_DUPLICATE,
  PDF_TEMPLATE_UPLOAD_SOURCE,
  PDF_TEMPLATE_PREVIEW,
} from "./actionType";

import {
  listPdfTemplatesSuccess,
  listPdfTemplatesFailure,
  renderPdfTemplateSuccess,
  renderPdfTemplateFailure,
  savePdfTemplateSuccess,
  savePdfTemplateFailure,
  deletePdfTemplateSuccess,
  deletePdfTemplateFailure,
  duplicatePdfTemplateSuccess,
  duplicatePdfTemplateFailure,
  uploadSourcePdfTemplateSuccess,
  uploadSourcePdfTemplateFailure,
  previewPdfTemplateSuccess,
  previewPdfTemplateFailure,
} from "./action";

import {
  listPdfTemplateApi,
  renderPdfTemplateApi,
  savePdfTemplateApi,
  deletePdfTemplateApi,
  duplicatePdfTemplateApi,
  uploadSourcePdfTemplateApi,
  previewPdfTemplateApi,
} from "../../helpers/fakebackend_helper";

// List PdfTemplates
function* listPdfTemplates() {
  try {
    const response = yield call(listPdfTemplateApi);
    yield put(listPdfTemplatesSuccess(response));
  } catch (error) {
    yield put(listPdfTemplatesFailure(error));
  }
}

function* listPdfTemplatesWatcher() {
  yield takeEvery(PDF_TEMPLATE_LIST, listPdfTemplates);
}

// Render PdfTemplate (designer bundle)
function* renderPdfTemplate({ payload }) {
  try {
    const response = yield call(renderPdfTemplateApi, payload);
    yield put(renderPdfTemplateSuccess(response));
  } catch (error) {
    yield put(renderPdfTemplateFailure(error));
  }
}

function* renderPdfTemplateWatcher() {
  yield takeEvery(PDF_TEMPLATE_RENDER, renderPdfTemplate);
}

// Save PdfTemplate
function* savePdfTemplate({ payload }) {
  try {
    const response = yield call(savePdfTemplateApi, payload);
    yield put(savePdfTemplateSuccess(response));
  } catch (error) {
    yield put(savePdfTemplateFailure(error));
  }
}

function* savePdfTemplateWatcher() {
  yield takeEvery(PDF_TEMPLATE_SAVE, savePdfTemplate);
}

// Delete PdfTemplate
function* deletePdfTemplate({ payload }) {
  try {
    const response = yield call(deletePdfTemplateApi, payload);
    yield put(deletePdfTemplateSuccess(response));
  } catch (error) {
    yield put(deletePdfTemplateFailure(error));
  }
}

function* deletePdfTemplateWatcher() {
  yield takeEvery(PDF_TEMPLATE_DELETE, deletePdfTemplate);
}

// Duplicate PdfTemplate
function* duplicatePdfTemplate({ payload }) {
  try {
    const response = yield call(duplicatePdfTemplateApi, payload);
    yield put(duplicatePdfTemplateSuccess(response));
  } catch (error) {
    yield put(duplicatePdfTemplateFailure(error));
  }
}

function* duplicatePdfTemplateWatcher() {
  yield takeEvery(PDF_TEMPLATE_DUPLICATE, duplicatePdfTemplate);
}

// Upload source PDF
function* uploadSourcePdfTemplate({ payload }) {
  try {
    const response = yield call(uploadSourcePdfTemplateApi, payload);
    yield put(uploadSourcePdfTemplateSuccess(response));
  } catch (error) {
    yield put(uploadSourcePdfTemplateFailure(error));
  }
}

function* uploadSourcePdfTemplateWatcher() {
  yield takeEvery(PDF_TEMPLATE_UPLOAD_SOURCE, uploadSourcePdfTemplate);
}

// Preview PdfTemplate
function* previewPdfTemplate({ payload }) {
  try {
    const response = yield call(previewPdfTemplateApi, payload);
    yield put(previewPdfTemplateSuccess(response));
  } catch (error) {
    yield put(previewPdfTemplateFailure(error));
  }
}

function* previewPdfTemplateWatcher() {
  yield takeEvery(PDF_TEMPLATE_PREVIEW, previewPdfTemplate);
}

export default function* PdfTemplate() {
  yield all([
    fork(listPdfTemplatesWatcher),
    fork(renderPdfTemplateWatcher),
    fork(savePdfTemplateWatcher),
    fork(deletePdfTemplateWatcher),
    fork(duplicatePdfTemplateWatcher),
    fork(uploadSourcePdfTemplateWatcher),
    fork(previewPdfTemplateWatcher),
  ]);
}
